import React from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from '@/constants';

const LoadingErrorPageBody: React.FC = () => {
  return (
    <div>
      <h1>Loading Error</h1>
      <p>
        There was a problem loading the requested resource. Please try again
        later.
      </p>
      <Link to={PATHS.APPLICANT.DASHBOARD}>Go to Home</Link>
    </div>
  );
};

export default LoadingErrorPageBody;
